module.exports = __webpack_public_path__ + "static/media/aaron_shi.934caded.png";